import React from 'react';
import { SubSection, Rows, hasRows, money, pctD } from '../StatRows';

/* "Jobs" accordion — College Scorecard career outcomes. This data has always
   been in the match-detail payload; web simply never rendered it.
   Mirrors `jobsBody` in MatchDetailSheet.swift.

   DELIBERATE OMISSION — do not "fix" this: `employment_rate_10yr` is present
   in the payload and is not shown on ANY platform. Scorecard's
   `10_yrs_after_entry.working_not_enrolled` counts include non-completers and
   produces nonsense rates (Bryant reports 15.5%). Only the clean
   4-yr-after-completion rate is shown. The 10-yr EARNINGS figure is sound and
   remains the headline row. */

function build(detail) {
  const e = detail.earnings;
  if (!e) return null;
  const m = e.major;
  return {
    e,
    m,
    instRows: [
      { label: 'Typical earnings — 10 yrs after entry', value: money(e.median_earn_10yr) },
      { label: 'Earnings — 4 yrs after completing', value: money(e.median_earn_4yr) },
      { label: 'Employment rate — 4 yrs after completing', value: pctD(e.employment_rate_4yr) },
      { label: 'Earn more than a typical HS grad', value: pctD(e.pct_earn_above_hs) },
    ],
    majorRows: m ? [
      { label: 'Earnings here', value: money(m.earnings) },
      { label: 'National median — this major', value: money(m.national_earnings) },
      { label: 'Median debt', value: money(m.debt) },
    ] : [],
  };
}

export function hasContent(detail) {
  const b = build(detail);
  return Boolean(b) && (hasRows(b.instRows) || hasRows(b.majorRows));
}

/** "$4,200 above the national median." — null unless both figures exist. */
function majorDelta(m) {
  if (m.earnings == null || m.national_earnings == null) return null;
  const d = m.earnings - m.national_earnings;
  if (d === 0) return 'On par with the national median for this major.';
  return `$${Math.abs(d).toLocaleString()} ${d > 0 ? 'above' : 'below'} the national median.`;
}

export default function JobsSection({ detail }) {
  const b = build(detail);
  if (!b) return null;
  const { e, m, instRows, majorRows } = b;

  const majorTitle = m && m.name ? `Your Major · ${m.name}` : 'Your Major';
  const delta = m ? majorDelta(m) : null;
  const baseline = money(e.hs_baseline);

  return (
    <>
      <SubSection title="Earnings & Employment" hasContent={hasRows(instRows)}>
        <Rows rows={instRows} />
        {e.pct_earn_above_hs != null && baseline && (
          <p className="sd-note">State HS-grad baseline: {baseline}/yr</p>
        )}
      </SubSection>

      {m && (
        <SubSection title={majorTitle} hasContent={hasRows(majorRows)}>
          <Rows rows={majorRows} />
          {delta && <p className="sd-note">{delta}</p>}
        </SubSection>
      )}

      <p className="sd-source">Source: U.S. Dept. of Education (College Scorecard)</p>
    </>
  );
}
